import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { PublicPageShell } from "@/components/landing/PublicPageShell";
import { ForRecruitersShowcase } from "@/components/landing/ForRecruitersShowcase";
import { TRUST_BADGES } from "@/data/homepageData";

const HIRE_STATS = [["100%", "AI-Verified Skills"], ["0", "Fake Resumes"], ["5", "Skill Tracks Covered"]];

export default function RecruiterLandingPage() {
  return (
    <PublicPageShell>
      <div data-testid="recruiter-landing-page">
        <div className="max-w-4xl mx-auto px-6 pt-16 pb-4 text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400">For Recruiters</span>
          <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-3">Hire Verified Performers, Not PDFs.</h1>
          <p className="text-slate-400 mt-4 max-w-xl mx-auto">Every candidate on Cloudivo earns their profile — AI Interview score, Boss Battles cleared, ATS-verified resume, and a global rank. See proof before you ever schedule a call.</p>
        </div>

        <div className="max-w-3xl mx-auto px-6 py-10 grid grid-cols-3 gap-4 text-center" data-testid="recruiter-hire-stats">
          {HIRE_STATS.map(([num, label]) => (
            <div key={label}>
              <div className="font-heading text-2xl sm:text-3xl font-bold text-white">{num}</div>
              <div className="text-xs text-slate-400 uppercase tracking-wider mt-1">{label}</div>
            </div>
          ))}
        </div>

        <ForRecruitersShowcase />

        <div className="max-w-4xl mx-auto px-6 py-10 flex flex-wrap items-center justify-center gap-3">
          {TRUST_BADGES.map((b) => (
            <span key={b} className="flex items-center gap-1.5 text-xs font-semibold text-slate-300 bg-white/[0.03] border border-white/10 rounded-full px-3.5 py-2">
              <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" /> {b}
            </span>
          ))}
        </div>

        <div className="max-w-3xl mx-auto px-6 py-16 text-center">
          <Link to="/recruiter/register" data-testid="recruiter-page-register-cta" className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold px-8 py-4 rounded-xl transition-all hover:-translate-y-0.5">
            Create Recruiter Account <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </PublicPageShell>
  );
}
